// Sends an uploaded image to the image-analysis endpoint. The backend saves the bot's reply (success or
// failure) into Messages/<docid> itself, so the chat picks it up through the Firestore listener.
export async function analyseImageAndPostReply({ analysisUrl, imageUrl, docid, shopId }) {
  try {
    const response = await fetch(analysisUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ image_url: imageUrl, docid, shop_id: shopId }),
    });
    if (!response.ok) {
      const responseBody = await response.json().catch(() => ({}));
      console.error("Image analysis failed:", response.status, responseBody.error);
    }
  } catch (error) {
    console.error("Image analysis request failed:", error);
  }
}
